import React from 'react';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { packageCancellationActionTypes } from './Constants';
import * as packageCancellationActions from './Actions';
import * as errorHandlerActions from '../errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_REQUEST,
			handleGetPackageCancellationDataRequest,
		),
		yield takeLatest(
			packageCancellationActionTypes.APPLY_OFFER_REQUEST,
			handleApplyOfferRequest,
		),
	]);
}

export function* handleGetPackageCancellationDataRequest() {
	try {
		const { data } = yield call(processRequest, 'subscriptions/cancellation_options');
		const { cancellation_options } = data || {};

		yield put(packageCancellationActions.setPackageCancellationData({ open: true }));

		yield put(
			packageCancellationActions.getPackageCancellationDataSuccess(cancellation_options),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleApplyOfferRequest(action) {
	try {
		const { type, eventData } = action.payload;
		const reqPayload = { chosen_offer: type, event_data: eventData };

		const { data } = yield call(
			processRequest,
			'subscriptions/accept_cancellation_offer',
			'POST',
			reqPayload,
		);

		yield put(packageCancellationActions.applyOfferSuccess(data));
		yield put(
			packageCancellationActions.setPackageCancellationData({
				step: 'confirmation',
				confirmationType: 'cancellation_offer_accepted',
			}),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(packageCancellationActions.applyOfferError());
	}
}
